import 'react-day-picker/style.css';
import './styled_day_picker.scss';

import React, { useState } from 'react';
import classnames from 'classnames';
import {
  DayPicker,
  PropsBase,
  PropsMulti,
  PropsMultiRequired,
  PropsRange,
  PropsRangeRequired,
  PropsSingle,
  PropsSingleRequired,
} from 'react-day-picker';
import { I18n } from '../../../locales/translate';
import { de, enGB } from 'date-fns/locale';
import { addYears } from 'date-fns';

type Props = Omit<PropsBase, 'locale' | 'fixedWeeks' | 'classNames' | 'weekStartsOn'> &
  (
    | PropsSingle
    | PropsSingleRequired
    | PropsMulti
    | PropsMultiRequired
    | PropsRange
    | PropsRangeRequired
    | {
        mode?: undefined;
        required?: undefined;
      }
  );

export function StyledDayPicker(props: Props): JSX.Element {
  const [displayedMonth, setDisplayedMonth] = useState<Date | undefined>(getInitialMonth());
  const navLayout = props.navLayout || 'around';

  function getInitialMonth(): Date | undefined {
    if (props.mode === 'multiple') {
      return props.selected?.[0];
    }
    if (props.mode === 'range') {
      return props.selected?.from;
    }
    if (props.mode === 'single') {
      return props.selected;
    }
    return new Date();
  }

  return (
    <DayPicker
      {...props}
      {...(props.defaultMonth
        ? {}
        : { defaultMonth: new Date(), month: displayedMonth, onMonthChange: (month) => setDisplayedMonth(month) })}
      fixedWeeks
      locale={I18n.locale === 'de' ? de : enGB}
      captionLayout={props.captionLayout || 'dropdown'}
      navLayout={navLayout}
      endMonth={props.endMonth ? props.endMonth : addYears(new Date(), 10)}
      classNames={{
        selected: classnames('styled-day-picker__day--selected', 'text', 'text--datepicker-day-selected'),
        today: 'styled-day-picker__day--today',
        day_button: 'styled-day-picker__day',
        day: classnames('text', 'text--datepicker-day', 'styled-day-picker__td'),
        disabled: classnames('styled-day-picker__day--disabled', 'text', 'text--datepicker-day-disabled'),

        chevron: 'styled-day-picker__chevron',
        months_dropdown: classnames('text', 'text--datepicker-select'),
        years_dropdown: classnames('text', 'text--datepicker-select'),
        month_grid: 'styled-day-picker__month-grid',
        months: 'styled-day-picker__months',
        range_end: classnames('styled-day-picker__day--end', 'text', 'text--datepicker-day-selected'),
        range_start: classnames('styled-day-picker__day--end', 'text', 'text--datepicker-day-selected'),
        range_middle: classnames('styled-day-picker__day--middle', 'text', 'text--datepicker-day-selected-secondary'),

        button_previous: classnames('styled-day-picker__arrow', {
          'styled-day-picker__arrow--multi-cal': navLayout === 'around',
          'styled-day-picker__arrow--previous': navLayout === 'around',
        }),
        button_next: classnames('styled-day-picker__arrow', {
          'styled-day-picker__arrow--multi-cal': navLayout === 'around',
          'styled-day-picker__arrow--next': navLayout === 'around',
        }),
        nav: 'styled-day-picker__nav',
      }}
    />
  );
}
